import '../styles/frequent.scss'

let Frequent = () => {
    return (
        <div className="frequent">
            <h2>Most Frequently Asked Question : </h2>

            <div className='frequent-container'>
                <h4>How long will it take to shipping ?</h4>
                <p>Mostly take between 10 to 14 days to shipping</p>
                <h4>How will it cost for Shipping ?</h4>
                <p>Shipping cost : $200</p>
                <h4>Are all the products original ?</h4>
                <p>Yes are original and we care to provide best quality</p>
            </div>
        </div>
    )
}

export default Frequent